import { useCallback } from 'react';
import { useAzureProvider } from 'src/azure/context';
import { useAutomationRuleSettings } from 'src/pages/automation-rule/settings/provider';
import { openPermissionPage } from 'src/utils/open-permission-page';

let debounceTimeout: NodeJS.Timeout | null = null;
const call_limit = 30;
let callCount = 0;

export function useMsEntraAuthorization() {
	const { applicationContext: { organizationName, organizationId }} = useAzureProvider();
	const { checkProjectAuthorization } = useAutomationRuleSettings();
  
	const goToPermissions = useCallback(() => {
		openPermissionPage({ organizationName, organizationId });

		const callReloadAuthClientInit = () => {
			if (debounceTimeout) {
				clearTimeout(debounceTimeout);
			}

			if (callCount < call_limit) {
				debounceTimeout = setTimeout(async () => {
					const result = await checkProjectAuthorization();

					if (!result?.userAuthorization) {
						callCount++;
						callReloadAuthClientInit();
					}
				}, 2000);
			}
		};

		callReloadAuthClientInit();

	}, []);

	return {
		goToPermissions,
		clearDebounceTimeout: () => {
			if (debounceTimeout) {
				clearTimeout(debounceTimeout);
			}
		},
	};
}